(() => {
  const root = document.querySelector('[data-tc-customer-account]');
  if (!root) return;

  const endpoint = root.dataset.endpoint;
  const locale = root.dataset.locale || document.documentElement.lang || 'fr';
  const isFr = locale.toLowerCase().startsWith('fr');
  const sessionKey = 'tc_customer_session_v2';
  const legacySessionKey = 'tc_customer_session_v1';
  const state = { mode: 'signup', channel: 'phone', phone: '', email: '', fullName: '', resendTimer: null };
  const requestTimeouts = { DASHBOARD: 15000, REQUEST_CODE: 15000, VERIFY_CODE: 45000 };

  const q = (s) => root.querySelector(s);
  const qa = (s) => Array.from(root.querySelectorAll(s));
  const auth = q('[data-tc-auth]');
  const dashboard = q('[data-tc-dashboard]');
  const loading = q('[data-tc-loading]');
  const detailsStep = q('[data-tc-step="details"]');
  const otpStep = q('[data-tc-step="otp"]');
  const detailsForm = q('[data-tc-details-form]');
  const otpForm = q('[data-tc-otp-form]');
  const signupFields = q('[data-tc-signup-fields]');
  const consent = q('[data-tc-consent]');
  const detailsError = q('[data-tc-details-error]');
  const otpError = q('[data-tc-otp-error]');
  const dashboardError = q('[data-tc-dashboard-error]');
  const resendButton = q('[data-tc-resend]');
  const countdown = q('[data-tc-countdown]');
  const otpInput = otpForm?.elements?.otp;

  const text = {
    signup: isFr ? 'Créer mon compte' : 'Create my account',
    login: isFr ? 'Se connecter' : 'Sign in',
    signupCopy: isFr ? 'Choisissez votre méthode de connexion. Aucun mot de passe à retenir.' : 'Choose how to sign in. No password to remember.',
    loginCopy: isFr ? 'Choisissez téléphone ou e-mail pour recevoir votre code sécurisé.' : 'Choose phone or email to receive your secure code.',
    smsButton: isFr ? 'Recevoir mon code SMS' : 'Send my SMS code',
    emailButton: isFr ? 'Recevoir mon code par e-mail' : 'Send my email code',
    timeout: isFr ? 'Le service met trop de temps à répondre. Réessayez dans quelques instants.' : 'The service is taking too long to respond. Please try again shortly.',
    sessionExpired: isFr ? 'Votre session a expiré. Reconnectez-vous avec votre téléphone ou votre e-mail.' : 'Your session has expired. Sign in again with your phone or email.',
    invalidPhone: isFr ? 'Vérifiez le numéro de téléphone.' : 'Check the phone number.',
    invalidEmail: isFr ? 'Indiquez une adresse e-mail valide.' : 'Enter a valid email address.',
    name: isFr ? 'Indiquez votre nom complet.' : 'Enter your full name.',
    terms: isFr ? 'Confirmez avoir pris connaissance de la politique de confidentialité pour continuer.' : 'Confirm that you have read the privacy policy to continue.',
    invalidCode: isFr ? 'Le code est incorrect ou a expiré.' : 'The code is incorrect or expired.',
    signupRequiredPhone: isFr ? 'Ce numéro n’a pas encore de compte TechConnect. Créez votre compte.' : 'This phone number does not have a TechConnect account yet. Create your account.',
    signupRequiredEmail: isFr ? 'Cette adresse e-mail n’a pas encore de compte TechConnect. Créez votre compte.' : 'This email address does not have a TechConnect account yet. Create your account.',
    noOrders: isFr ? 'Aucune commande pour le moment.' : 'No orders yet.',
    track: isFr ? 'Suivre' : 'Track',
  };

  function setLoading(on) { if (loading) loading.hidden = !on; }
  function error(el, message = '') { if (!el) return; el.textContent = message; el.hidden = !message; }

  function setMode(mode) {
    state.mode = mode === 'login' ? 'login' : 'signup';
    qa('[data-tc-mode]').forEach((btn) => {
      const active = btn.dataset.tcMode === state.mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (signupFields) signupFields.hidden = state.mode === 'login';
    if (consent) consent.hidden = state.mode === 'login';
    const title = q('[data-tc-step-title]');
    const copy = q('[data-tc-step-copy]');
    if (title) title.textContent = state.mode === 'signup' ? text.signup : text.login;
    if (copy) copy.textContent = state.mode === 'signup' ? text.signupCopy : text.loginCopy;
    error(detailsError);
  }

  function setChannel(channel) {
    state.channel = channel === 'email' ? 'email' : 'phone';
    qa('[data-tc-channel]').forEach((btn) => {
      const active = btn.dataset.tcChannel === state.channel;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    qa('[data-tc-method-panel]').forEach((panel) => { panel.hidden = panel.dataset.tcMethodPanel !== state.channel; });
    const sendLabel = q('[data-tc-send-label]');
    if (sendLabel) sendLabel.textContent = state.channel === 'phone' ? text.smsButton : text.emailButton;
    error(detailsError);
  }

  function normalizePhone() {
    const dial = String(detailsForm?.elements?.dialCode?.value || '');
    let raw = String(detailsForm?.elements?.phone?.value || '').trim().replace(/[\s().-]/g, '');
    if (!raw) return null;
    if (raw.startsWith('00')) raw = '+' + raw.slice(2);
    if (raw.startsWith('+')) return /^\+[1-9]\d{7,14}$/.test(raw) ? raw : null;
    raw = raw.replace(/^0+/, '');
    const value = dial + raw;
    return /^\+[1-9]\d{7,14}$/.test(value) ? value : null;
  }

  function normalizeEmail() {
    const value = String(detailsForm?.elements?.email?.value || '').trim().toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? value : null;
  }

  function identityPayload(action, code) {
    const payload = { action, mode: state.mode, channel: state.channel, fullName: state.fullName, locale };
    if (state.channel === 'phone') payload.phone = state.phone;
    else payload.email = state.email;
    if (code) payload.code = code;
    return payload;
  }

  async function api(payload, accessToken) {
    const headers = { 'content-type': 'application/json', accept: 'application/json' };
    if (accessToken) headers.authorization = `Bearer ${accessToken}`;
    const action = String(payload?.action || '').toUpperCase();
    const timeoutMs = requestTimeouts[action] || 15000;
    const controller = new AbortController();
    let timedOut = false;
    const timeoutId = window.setTimeout(() => { timedOut = true; controller.abort(); }, timeoutMs);
    try {
      const response = await fetch(endpoint, { method: 'POST', headers, body: JSON.stringify(payload), credentials: 'omit', signal: controller.signal });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data?.ok) {
        const e = new Error(data?.message || data?.code || 'REQUEST_FAILED');
        e.code = data?.code || 'REQUEST_FAILED';
        e.retryAfter = Number(data?.retryAfter || 0);
        throw e;
      }
      return data;
    } catch (e) {
      if (timedOut || e?.name === 'AbortError') { const timeoutError = new Error('REQUEST_TIMEOUT'); timeoutError.code = 'REQUEST_TIMEOUT'; throw timeoutError; }
      throw e;
    } finally { window.clearTimeout(timeoutId); }
  }

  function mapError(e) {
    const code = String(e?.code || e?.message || '');
    if (code === 'REQUEST_TIMEOUT') return text.timeout;
    if (code === 'INVALID_PHONE') return text.invalidPhone;
    if (code === 'INVALID_EMAIL' || code === 'EMAIL_REQUIRED') return text.invalidEmail;
    if (code === 'NAME_REQUIRED') return text.name;
    if (code === 'SIGNUP_REQUIRED') return state.channel === 'email' ? text.signupRequiredEmail : text.signupRequiredPhone;
    if (code === 'INVALID_OR_EXPIRED_CODE' || code === 'INVALID_CODE_FORMAT') return text.invalidCode;
    if (code === 'IDENTITY_ALREADY_LINKED') return isFr ? 'Cette identité est déjà associée à un autre compte TechConnect.' : 'This identity is already linked to another TechConnect account.';
    if (code === 'IDENTITY_MISMATCH') return isFr ? 'La vérification de l’identité a échoué. Recommencez.' : 'Identity verification failed. Please try again.';
    if (code === 'RESEND_TOO_SOON') return isFr ? `Patientez ${Math.max(1, e.retryAfter)} s avant de renvoyer le code.` : `Wait ${Math.max(1, e.retryAfter)}s before resending.`;
    if (code === 'TOO_MANY_ATTEMPTS' || code === 'RATE_LIMITED') return isFr ? 'Trop de tentatives. Réessayez dans quelques minutes.' : 'Too many attempts. Try again in a few minutes.';
    if (code === 'SMS_PROVIDER_NOT_CONFIGURED') return isFr ? 'Le service SMS doit encore être activé. Vous pouvez utiliser l’inscription par e-mail.' : 'SMS service still needs to be activated. You can use email sign-up.';
    if (code === 'SMS_SEND_FAILED') return isFr ? 'Le SMS n’a pas pu être envoyé. Réessayez.' : 'The SMS could not be sent. Try again.';
    if (code === 'EMAIL_SEND_FAILED') return isFr ? 'Le code e-mail n’a pas pu être envoyé. Réessayez dans quelques instants.' : 'The email code could not be sent. Please try again shortly.';
    return isFr ? 'Une erreur est survenue. Réessayez.' : 'Something went wrong. Please try again.';
  }

  function showOtp() {
    detailsStep.hidden = true;
    otpStep.hidden = false;
    const identityLabel = q('[data-tc-identity-label]');
    if (identityLabel) identityLabel.textContent = state.channel === 'phone' ? state.phone : state.email;
    const otpTitle = q('[data-tc-otp-title]');
    if (otpTitle) otpTitle.textContent = state.channel === 'phone' ? (isFr ? 'Confirmez votre numéro' : 'Confirm your phone') : (isFr ? 'Confirmez votre e-mail' : 'Confirm your email');
    if (otpInput) { otpInput.value = ''; otpInput.focus(); }
    startCountdown(60);
  }

  function showDetails() { otpStep.hidden = true; detailsStep.hidden = false; error(otpError); }

  function startCountdown(seconds) {
    if (state.resendTimer) window.clearInterval(state.resendTimer);
    let left = Math.max(0, Number(seconds) || 0);
    resendButton.disabled = left > 0;
    const tick = () => {
      if (countdown) countdown.textContent = left > 0 ? `(${left}s)` : '';
      if (left <= 0) { resendButton.disabled = false; if (state.resendTimer) window.clearInterval(state.resendTimer); state.resendTimer = null; return; }
      left -= 1;
    };
    tick();
    state.resendTimer = window.setInterval(tick, 1000);
  }

  function saveSession(session) { if (session?.accessToken) { sessionStorage.setItem(sessionKey, JSON.stringify(session)); sessionStorage.removeItem(legacySessionKey); } }
  function getSession() {
    for (const key of [sessionKey, legacySessionKey]) {
      try {
        const s = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!s?.accessToken) continue;
        if (s.expiresAt && Number(s.expiresAt) * 1000 <= Date.now() + 5000) { sessionStorage.removeItem(key); continue; }
        return s;
      } catch (_) { sessionStorage.removeItem(key); }
    }
    return null;
  }
  function clearSession() { sessionStorage.removeItem(sessionKey); sessionStorage.removeItem(legacySessionKey); }

  function money(value) {
    if (!value?.amount || !value?.currencyCode) return '—';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: value.currencyCode }).format(Number(value.amount)); }
    catch (_) { return `${value.amount} ${value.currencyCode}`; }
  }
  function date(value) { try { return new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(value)); } catch (_) { return ''; } }
  function statusLabel(value) {
    const mapFr = { PAID:'Payée',PENDING:'Paiement en attente',AUTHORIZED:'Autorisée',PARTIALLY_PAID:'Partiellement payée',REFUNDED:'Remboursée',PARTIALLY_REFUNDED:'Partiellement remboursée',FULFILLED:'Expédiée',UNFULFILLED:'À préparer',PARTIALLY_FULFILLED:'Partiellement expédiée',IN_PROGRESS:'En préparation',ON_HOLD:'En attente',SCHEDULED:'Planifiée',OPEN:'Ouverte' };
    const key = String(value || '').toUpperCase();
    return (isFr ? mapFr[key] : null) || key.replaceAll('_', ' ').toLowerCase();
  }
  function escapeHtml(v) { return String(v ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c])); }
  function escapeAttr(v) { return escapeHtml(v).replace(/`/g, '&#096;'); }

  function renderDashboard(payload) {
    const data = payload?.dashboard || payload;
    const profile = data?.profile || {};
    const customer = data?.customer || {};
    const orders = Array.isArray(data?.orders) ? data.orders : [];
    auth.hidden = true;
    dashboard.hidden = false;
    q('[data-tc-customer-name]').textContent = customer.firstName || profile.fullName?.split(/\s+/)[0] || (isFr ? 'Client' : 'Customer');
    q('[data-tc-profile-name]').textContent = profile.fullName || customer.displayName || '—';
    q('[data-tc-profile-email]').textContent = profile.email || '—';
    q('[data-tc-profile-phone]').textContent = profile.phone || '—';
    q('[data-tc-order-count]').textContent = customer.numberOfOrders || String(orders.length);
    q('[data-tc-spent]').textContent = money(customer.amountSpent);
    const verified = q('[data-tc-verified-badge]');
    if (verified) verified.textContent = profile.primaryChannel === 'email' ? (isFr ? '✓ E-mail vérifié' : '✓ Email verified') : (isFr ? '✓ Téléphone vérifié' : '✓ Phone verified');
    const box = q('[data-tc-orders]');
    if (!orders.length) box.innerHTML = `<div class="tc-dashboard__empty">${text.noOrders}</div>`;
    else box.innerHTML = orders.map((o) => `<article class="tc-order"><div class="tc-order__id"><strong>${escapeHtml(o.name || '')}</strong><span>${escapeHtml(date(o.createdAt))}</span></div><div class="tc-order__status"><span>${escapeHtml(statusLabel(o.financialStatus))}</span><span>${escapeHtml(statusLabel(o.fulfillmentStatus))}</span></div><div class="tc-order__amount"><strong>${escapeHtml(money(o.total))}</strong>${o.statusUrl ? `<a href="${escapeAttr(o.statusUrl)}" target="_blank" rel="noopener">${text.track}</a>` : ''}</div></article>`).join('');
    error(dashboardError, data?.syncPending ? (isFr ? 'Votre profil est actif. La synchronisation Shopify sera retentée automatiquement.' : 'Your profile is active. Shopify sync will retry automatically.') : '');
  }

  qa('[data-tc-mode]').forEach((btn) => btn.addEventListener('click', () => setMode(btn.dataset.tcMode)));
  qa('[data-tc-channel]').forEach((btn) => btn.addEventListener('click', () => setChannel(btn.dataset.tcChannel)));
  q('[data-tc-edit-identity]')?.addEventListener('click', showDetails);

  detailsForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    error(detailsError);
    state.fullName = String(detailsForm.elements.fullName?.value || '').trim();
    if (state.channel === 'phone') {
      state.phone = normalizePhone();
      if (!state.phone) return error(detailsError, text.invalidPhone);
    } else {
      state.email = normalizeEmail();
      if (!state.email) return error(detailsError, text.invalidEmail);
    }
    if (state.mode === 'signup') {
      if (state.fullName.length < 2) return error(detailsError, text.name);
      if (!detailsForm.elements.terms?.checked) return error(detailsError, text.terms);
    }
    try {
      setLoading(true);
      const data = await api(identityPayload('REQUEST_CODE'));
      showOtp();
      startCountdown(data.retryAfter || 60);
    } catch (e) { error(detailsError, mapError(e)); }
    finally { setLoading(false); }
  });

  otpForm?.addEventListener('submit', verify);
  otpInput?.addEventListener('input', () => { otpInput.value = otpInput.value.replace(/\D/g, '').slice(0, 6); if (otpInput.value.length === 6) otpForm.requestSubmit(); });

  async function verify(event) {
    if (event) event.preventDefault();
    error(otpError);
    const code = String(otpInput?.value || '').replace(/\D/g, '');
    if (code.length !== 6) return error(otpError, text.invalidCode);
    try {
      setLoading(true);
      const data = await api(identityPayload('VERIFY_CODE', code));
      saveSession(data.session);
      renderDashboard(data.dashboard || data);
    } catch (e) {
      if (e?.code === 'SIGNUP_REQUIRED') { setMode('signup'); showDetails(); error(detailsError, mapError(e)); }
      else { error(otpError, mapError(e)); otpInput?.select(); }
    } finally { setLoading(false); }
  }

  resendButton?.addEventListener('click', async () => {
    error(otpError);
    try { resendButton.disabled = true; const data = await api(identityPayload('REQUEST_CODE')); startCountdown(data.retryAfter || 60); }
    catch (e) { error(otpError, mapError(e)); startCountdown(e?.retryAfter || 10); }
  });

  q('[data-tc-signout]')?.addEventListener('click', () => {
    clearSession();
    dashboard.hidden = true;
    auth.hidden = false;
    setMode('login');
    setChannel('phone');
    showDetails();
    detailsForm?.reset();
  });

  async function restore() {
    const session = getSession();
    if (!session?.accessToken) { setLoading(false); return; }
    try { setLoading(true); const data = await api({ action: 'DASHBOARD' }, session.accessToken); renderDashboard(data); }
    catch (e) {
      clearSession();
      dashboard.hidden = true;
      auth.hidden = false;
      setMode('login');
      showDetails();
      const code = String(e?.code || e?.message || '');
      error(detailsError, ['AUTH_REQUIRED','INVALID_SESSION','VERIFIED_PROFILE_REQUIRED'].includes(code) ? text.sessionExpired : mapError(e));
    } finally { setLoading(false); }
  }

  setMode('signup');
  setChannel('phone');
  restore();
})();
